module.exports = __webpack_public_path__ + "media/Audio15_f.e023f9ce.wav";